import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Car, Search, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StatusCheckerPage = () => {
  const [cod, setCod] = useState("");
  const [codVerificare, setCodVerificare] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(false);

  const handleCheck = async (e) => {
    e.preventDefault();
    if (!cod.trim()) return;
    setChecking(true);
    setResult(null);
    setError("");
    try {
      const params = new URLSearchParams({ cod: cod.trim() });
      if (codVerificare.trim()) params.append("cod_verificare", codVerificare.trim());
      const res = await axios.get(`${API}/public/check-status?${params}`);
      setResult(res.data);
    } catch {
      setError("Dosarul nu a fost gasit. Verificati codurile introduse.");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col">
      <header className="bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2" data-testid="status-logo">
              <div className="w-10 h-10 bg-emerald-500 rounded-xl flex items-center justify-center">
                <Car className="w-6 h-6 text-white" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-lg text-white leading-tight">AUTO PRO</span>
                <span className="text-xs text-emerald-400 font-medium -mt-1">DAUNE</span>
              </div>
            </Link>
            <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-testid="back-home">
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm">Inapoi</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-lg text-center">
          <div className="w-16 h-16 bg-emerald-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Search className="w-8 h-8 text-emerald-400" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-3" data-testid="status-title">Verifica Status Dosar</h1>
          <p className="text-gray-400 mb-8">Introdu codul dosarului si codul de verificare pentru a vedea statusul curent.</p>

          <form onSubmit={handleCheck} className="max-w-md mx-auto mb-6 space-y-3">
            <div className="flex gap-2">
              <input
                value={cod}
                onChange={e => setCod(e.target.value.toUpperCase())}
                placeholder="Cod dosar: APD-0001"
                className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 text-white rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-transparent placeholder-gray-500"
                data-testid="check-status-input"
              />
              <input
                value={codVerificare}
                onChange={e => setCodVerificare(e.target.value.toUpperCase())}
                placeholder="Cod verificare"
                className="w-36 px-4 py-3 bg-gray-800 border border-gray-700 text-white rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-transparent placeholder-gray-500 font-mono"
                data-testid="check-verification-input"
              />
            </div>
            <button
              type="submit"
              disabled={checking}
              className="w-full px-6 py-3 bg-emerald-500 text-white rounded-xl hover:bg-emerald-600 disabled:bg-emerald-300 font-medium"
              data-testid="check-status-btn"
            >
              {checking ? "Se verifica..." : "Verifica Status"}
            </button>
          </form>

          {result && (
            <div className="p-6 bg-emerald-900/30 border border-emerald-500/30 rounded-xl text-left max-w-md mx-auto" data-testid="check-status-result">
              <div className="flex justify-between items-center mb-3">
                <span className="text-emerald-400 font-mono font-bold text-lg">{result.numar_dosar}</span>
                <span className="px-3 py-1 bg-emerald-500/20 text-emerald-300 rounded-full text-sm font-medium">{result.status}</span>
              </div>
              <p className="text-gray-400 text-sm">Ultima actualizare: {result.ultima_actualizare}</p>
              {result.nota && (
                <div className="mt-4 p-4 bg-amber-500/10 border border-amber-500/20 rounded-lg" data-testid="visible-note-display">
                  <p className="text-amber-300 text-sm font-medium">Nota: <span className="text-white font-normal">{result.nota}</span></p>
                </div>
              )}
            </div>
          )}
          {error && <p className="mt-4 text-red-400 text-sm" data-testid="check-status-error">{error}</p>}
        </div>
      </main>
    </div>
  );
};

export default StatusCheckerPage;
